import { useState } from "react";
import { IonButton, IonIcon } from "@ionic/react";
import { cubeOutline } from 'ionicons/icons';
import { useRollbar } from '@rollbar/react';

export default function RollbarTest() {
  const rollbar = useRollbar();
  const [count, setCount] = useState(0);
  const testRollbar = () => {
    if (count == 2) rollbar.debug('Rollbar Test');
    setCount(count + 1);
  };
  return (
    <IonButton onClick={testRollbar}>
      <IonIcon slot="icon-only" icon={cubeOutline} color="light"/>
    </IonButton>
  );
}
